import { ReducerFactory } from 'redux-actions-ts-reducer';

import { GlobalState } from '../../rootReducer';

import { setExternalLinkToOpen } from './OpenExternalLinkConfirmModalActions';

class State {
    externalLinkToOpen = '';
}

export default new ReducerFactory(new State())
    .addReducer(
        setExternalLinkToOpen,
        (state, action): State => {
            return {
                ...state,
                externalLinkToOpen: action.payload,
            };
        },
    )
    .toReducer();

export { State as OpenExternalLinkState };

export const selectExternalLinkToOpen = (state: GlobalState) => state.openExternalLink.externalLinkToOpen;
